// Stash a pending checkout intent across an auth round-trip.
// BuyButton writes it before sending the visitor to /auth; PaymentContext reads
// it after authentication completes and immediately starts Stripe Checkout.

const PENDING_CHECKOUT_KEY = 'pending_checkout_plan';

export function setPendingCheckout(planId, context) {
  try {
    sessionStorage.setItem(
      PENDING_CHECKOUT_KEY,
      JSON.stringify({ planId, context, ts: Date.now() })
    );
  } catch {}
}

export function readPendingCheckout() {
  try {
    const raw = sessionStorage.getItem(PENDING_CHECKOUT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingCheckout() {
  try {
    sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
  } catch {}
}
